import React from 'react';
import { useHashRoute } from '../../hooks/useHashRoute';
import { ContactsPanel } from './contacts';
import { QualityCheckCard } from './workflow';
import QualityCheckView, { type QualityCheckTab } from './QualityCheckView';
import styles from './QualityCheckRoute.module.css';

export interface QualityCheckRouteProps {
  className?: string;
  initialTab?: QualityCheckTab;
}

const QualityCheckRoute: React.FC<QualityCheckRouteProps> = ({ className = '', initialTab }) => {
  const { view, params } = useHashRoute('quality-check');
  const programId = params.program_id;
  const programCode = params.program_code;

  const effectiveInitialTab: QualityCheckTab | undefined = initialTab ?? (view === 'operations'
    ? 'operations'
    : view === 'manual-entry'
      ? 'manual'
      : view === 'enrichment-verification'
        ? 'verification'
        : undefined);

  // NEW: quality-checkv2 route with comprehensive QC workflow
  if (view === 'quality-checkv2' && programId && programCode) {
    return (
      <div className={className}>
        <QualityCheckCard programId={programId} baciCode={programCode} />
      </div>
    );
  }

  // NEW: quality-checkv2 new program workflow (no params)
  if (view === 'quality-checkv2' && !programId && !programCode) {
    return (
      <div className={className}>
        <QualityCheckCard
          programId="new-program-check"
          baciCode="new-program-check"
          mode="new-program"
        />
      </div>
    );
  }

  // NEW: quality-checkv2 missing required params
  if (view === 'quality-checkv2' && (!programId || !programCode)) {
    return (
      <div className={className}>
        <div style={{ padding: '3rem 1.5rem', textAlign: 'center' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
            Invalid Route Parameters
          </h2>
          <p style={{ fontSize: '0.875rem', color: '#6b7280' }}>
            Quality Check v2 requires both program_id and program_code.{' '}
            <a
              href="#data-quality"
              style={{ color: 'var(--color-brand, #1c8e1c)', textDecoration: 'underline' }}
            >
              Return to Data Quality
            </a>
          </p>
        </div>
      </div>
    );
  }

  // LEGACY: quality-check route with old ContactsPanel
  if (view === 'quality-check' && programId) {
    return (
      <div className={className}>
        <ContactsPanel programId={programId} />
      </div>
    );
  }

  // LEGACY: quality-check missing program_id
  if (view === 'quality-check' && !programId) {
    return (
      <div className={className}>
        <div className={styles.noProgramContainer}>
          <div className={styles.optionsGrid}>
            <div className={styles.optionCard}>
              <h3 className={styles.optionTitle}>Check an Existing Program</h3>
              <p className={styles.optionBody}>
                Pick a program from the program list that is already in the BAM Database.
              </p>
              <a
                className={`${styles.optionLink} ${styles.optionLinkPrimary}`}
                href="#data-quality?sb=categories&sd=desc"
              >
                Select Program
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Fallback to legacy view (shouldn't reach here)
  return (
    <div className={className}>
      <QualityCheckView initialTab={effectiveInitialTab} />
    </div>
  );
};

export default QualityCheckRoute;
